import PAGE_EXPERIMENTS_CONFIG_LIST from './configs/pageExperiments.configList'
import { pageExperimentInitialiser } from './helpers/pageExperiments.initialiser'
import { getAssignedBucketForPageExperiment } from './pageExperiment.state'
import { IPageLevelExperimentConfig } from './pageExperiments.types'

class PageExperimentManager {
  readonly assignedExperimentBucketsForUser: Record<string, string>
  readonly pageLevelExperiments: IPageLevelExperimentConfig[]

  constructor() {
    this.pageLevelExperiments = PAGE_EXPERIMENTS_CONFIG_LIST
    this.assignedExperimentBucketsForUser = {}
  }

  initializePageExperiments = () => {
    this.pageLevelExperiments.forEach(pageExperimentInitialiser)
  }

  getUserBucketsForEventLogging = () => {
    const experimentBuckets = []
    for (const experiment of this.pageLevelExperiments) {
      const bucketName = getAssignedBucketForPageExperiment(experiment.name)
      if (bucketName) {
        experimentBuckets.push({
          experimentName: experiment.name,
          bucketName: bucketName,
        })
      }
    }
    return experimentBuckets
  }

  initialize() {
    this.initializePageExperiments()
  }
}

const pageExperimentManager = new PageExperimentManager()

Object.freeze(pageExperimentManager)

if (typeof window !== 'undefined') {
  window.pageExperimentManager = pageExperimentManager
}

export default pageExperimentManager
